import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { jsx as _jsx } from "react/jsx-runtime";
export let AlertType;
(function (AlertType) {
  AlertType["success"] = "success";
  AlertType["danger"] = "danger";
})(AlertType || (AlertType = {}));
export const clearAlerts = () => {
  Object.keys(FloatingAlertStore.getAlerts()).forEach(alertId => {
    FloatingAlertStore.removeAlert(alertId);
  });
};
export const showAlert = ({
  type,
  message,
  title,
  sticky
}) => FloatingAlertStore.addAlert({
  message,
  titleText: title,
  type,
  sticky
});
export const showGenericUpdateSuccess = () => {
  showAlert({
    type: AlertType.success,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "calling-orchestration-shared-library.alert-store.updateSuccess.title"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "calling-orchestration-shared-library.alert-store.updateSuccess.message",
      "data-selenium-test": "alert-success",
      "data-test-id": "alert-success"
    })
  });
};
export const showGenericUpdateFailure = () => {
  showAlert({
    type: AlertType.danger,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "calling-orchestration-shared-library.alert-store.updateFailure.title"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "calling-orchestration-shared-library.alert-store.updateFailure.message"
    })
  });
};